import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";


import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "../css/PhotoModal.css"

export default function PhotoModal({ photos, selectedIndex, onClose }) {

    return (
        <Lightbox
            open={selectedIndex !== null}
            index={selectedIndex}
            slides={photos.map(photo => ({
                src: photo.src,
                // title: photo.name,
                description: <div className="photo-description"><strong>{photo.name}</strong><br />
{photo.project} {photo.year}</div>
            }))}
            close={onClose}
            plugins={[Zoom, Captions]}
        />
    );
}
